module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAXUlEQVQ4T+2UsQ2AQAwD7bmA6fmf61AkapwOCT5NipxSOHasRgFDEraPhDsBNQeobjvyEVgLo0QR+KCGwClp7/ixwUzfKdgacAcZfzxKR5j1HB5Ves02laZ62DFRF9z4UpZhj7O6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/common/plus.png
// module id = 8+zw
// module chunks = 256